import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Model, Opts } from "@ofqual/portal-core/core/types";
import { API_HOST_REFDATA } from "../config";

export class QualificationTypesService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${API_HOST_REFDATA}/qualificationTypes`;
    const data = await super.getRequest<Model[]>(url, opts)

    data.push(  
    {
      "id":-1,
      "description":"N/A",
      "isNotApplicable":false,
      "validFrom":"1900-01-01T00:00:00",
      "validUntil":"2099-12-31T00:00:00",
      "active":true,
      "additionalRegulatoryRequirements":false,
      "isRecognitionQualificationType":false,
      "ofqualAccreditationRequirement":false
   })

    return data;
  }
}